import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { CouponType } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Add course's coupon
 * @param course_id
 * @param version
 * @param coupon
 */
const addCourseCoupon = (
  course_id: string | string[],
  version: number,
  coupon: CouponType
): Promise<CouponType[]> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + course_id + '/' + version + '/coupons'
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    const data = { coupon }
    AxiosClient.put(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default addCourseCoupon
